function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupplyChain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.909,1.857C0.909,1.147 1.485,0.571 2.195,0.571L7.698,0.571C8.159,0.571 8.585,0.819 8.814,1.219L11.753,6.362C11.979,6.757 11.979,7.243 11.753,7.638L8.814,12.781C8.585,13.181 8.159,13.429 7.698,13.429L2.195,13.429C1.485,13.429 0.909,12.853 0.909,12.143L0.909,1.857ZM2.195,1.429C1.958,1.429 1.767,1.62 1.767,1.857L1.767,12.143C1.767,12.38 1.958,12.571 2.195,12.571L7.698,12.571C7.851,12.571 7.993,12.489 8.07,12.355L11.009,7.213C11.084,7.081 11.084,6.919 11.009,6.787L8.07,1.645C7.993,1.511 7.851,1.429 7.698,1.429L2.195,1.429Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.922,1C11.922,0.763 12.114,0.571 12.351,0.571L15.282,0.571C15.743,0.571 16.169,0.819 16.398,1.219L19.337,6.362C19.563,6.757 19.563,7.243 19.337,7.638L16.398,12.781C16.169,13.181 15.743,13.429 15.282,13.429L12.351,13.429C12.114,13.429 11.922,13.237 11.922,13C11.922,12.763 12.114,12.571 12.351,12.571L15.282,12.571C15.436,12.571 15.578,12.489 15.654,12.355L18.593,7.213C18.668,7.081 18.668,6.919 18.593,6.787L15.654,1.645C15.578,1.511 15.436,1.429 15.282,1.429L12.351,1.429C12.114,1.429 11.922,1.237 11.922,1Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.506,1C19.506,0.763 19.698,0.571 19.935,0.571L22.866,0.571C23.328,0.571 23.754,0.819 23.983,1.219L26.921,6.362C27.147,6.757 27.147,7.243 26.921,7.638L23.983,12.781C23.754,13.181 23.328,13.429 22.866,13.429L19.935,13.429C19.698,13.429 19.506,13.237 19.506,13C19.506,12.763 19.698,12.571 19.935,12.571L22.866,12.571C23.02,12.571 23.162,12.489 23.238,12.355L26.177,7.213C26.252,7.081 26.252,6.919 26.177,6.787L23.238,1.645C23.162,1.511 23.02,1.429 22.866,1.429L19.935,1.429C19.698,1.429 19.506,1.237 19.506,1Z",
    style: {
      fill: "white"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupplyChain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/supply-chain.0d5523127006154bc415b439e3f91014.svg";